export type ChargerWsGroup = "bcu12" | "bcu34" | "pblr" | "other";

export type ChargerGroupCounts = {
  bcu12: number;
  bcu34: number;
  pblr: number;
  other: number;
  count: number;
};

export const CHARGER_WS_GROUP_LABELS: Record<ChargerWsGroup, string> = {
  bcu12: "BCU1/2",
  bcu34: "BCU3/4",
  pblr: "PBLR",
  other: "Other",
};

/** Bottom → top stack: BCU1/2, BCU3/4, PBLR. */
export const CHARGER_WS_STACK_ORDER: ChargerWsGroup[] = ["bcu12", "bcu34", "pblr", "other"];

export type ChargerWsGroupStyle = { line: string; fill: string };

/** Line + translucent fill — stacked layers blend like the original single-series chart. */
export const CHARGER_WS_GROUP_STYLE: Record<ChargerWsGroup, ChargerWsGroupStyle> = {
  bcu12: { line: "#0d9488", fill: "rgba(13, 148, 136, 0.38)" },
  bcu34: { line: "#2563eb", fill: "rgba(37, 99, 235, 0.28)" },
  pblr: { line: "#d97706", fill: "rgba(217, 119, 6, 0.42)" },
  other: { line: "#64748b", fill: "rgba(100, 116, 139, 0.22)" },
};

export function chargerWsGroup(id: string): ChargerWsGroup {
  const u = id.toUpperCase();
  if (u.startsWith("BCU1") || u.startsWith("BCU2")) return "bcu12";
  if (u.startsWith("BCU3") || u.startsWith("BCU4")) return "bcu34";
  if (u.startsWith("PBLR")) return "pblr";
  return "other";
}

/** BCU3/4 and PBLR chargers expose OCPP trigger test actions. */
export function chargerHasTestSubmenu(id: string): boolean {
  const group = chargerWsGroup(id);
  return group === "bcu34" || group === "pblr";
}

export function countChargerGroups(chargerIds: Iterable<string>): ChargerGroupCounts {
  const counts = { bcu12: 0, bcu34: 0, pblr: 0, other: 0 };
  for (const id of chargerIds) {
    counts[chargerWsGroup(id)] += 1;
  }
  return {
    ...counts,
    count: counts.bcu12 + counts.bcu34 + counts.pblr + counts.other,
  };
}
